import {
  createContext,
  useContext,
  useState,
  useMemo,
  PropsWithChildren,
  memo,
} from 'react';

export type CosmosLayoutState = {
  leftNavOpen: boolean;
  setLeftNavOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const CosmosLayoutContext = createContext<CosmosLayoutState | undefined>(undefined);

export const useCosmosLayout = () => {
  const context = useContext(CosmosLayoutContext);
  if (!context) {
    throw new Error('useCosmosLayout must be used within a CosmosLayoutProvider');
  }
  return context;
};

/**
 * Simple layout state provider
 * - Left Nav open/closed state
 */
export const CosmosLayoutProvider = memo(({ children }: PropsWithChildren) => {
  const [leftNavOpen, setLeftNavOpen] = useState<boolean>(false);

  const contextValue = useMemo(() => {
    return {
      leftNavOpen: leftNavOpen,
      setLeftNavOpen: setLeftNavOpen,
    };
  }, [leftNavOpen]);

  return (
    <CosmosLayoutContext.Provider value={contextValue}>
      {children}
    </CosmosLayoutContext.Provider>
  );
});
CosmosLayoutProvider.displayName = 'CosmosLayoutProvider';
